import React from 'react';
import { FormControlLabel, Radio, RadioGroup, Stack, TextField, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import {
  validateRoutingNumber,
} from 'app/util/fieldValidations';

const BankAccountDetails = ({
  payout,
  setPayout,
  invalidFields,
}) => {
  const bankNameErrored = invalidFields.includes('bank_name');
  const accountNumberErrored = invalidFields.includes('account_number');

  const isRoutingNumberValid = validateRoutingNumber(payout.routingNumber);
  const accountConfirmationError = payout.accountNumberConfirmation?.length > 0 && payout.bankAccountNumber !== payout.accountNumberConfirmation;

  return (
    <Stack flex={1}>
      <Typography variant="subtitle1" my={1}>Bank Account Details</Typography>
      <TextField
        label="Bank Name"
        size="small"
        value={payout.bankName}
        onChange={(e) => setPayout({ ...payout, bankName: e.target.value })}
        error={bankNameErrored}
      />

      <RadioGroup
        aria-labelledby=""
        value={payout.accountType}
        onChange={(e) => setPayout({ ...payout, accountType: e.target.value })}
        name="radio-buttons-group"
      >
        <FormControlLabel value="0" control={<Radio />} label="Checkings" />
        <FormControlLabel value="1" control={<Radio />} label="Savings" />
      </RadioGroup>

      <Stack flex={1} rowGap={2}>
        <Stack flexDirection="row" alignItems="center" columnGap={2}>
          <img style={{ width: 15, height: 20 }} src="/plus_frontend/assets/txn/routing_number_symbol.gif" alt="routing number" />
          <TextField
            sx={{ flex: 1 }}
            label="Routing Number"
            size="small"
            value={payout.routingNumber}
            onChange={(e) => setPayout({ ...payout, routingNumber: e.target.value.replace(/\D/g, '') })}
            autoComplete="off"
            autoCorrect="off"
            autoSave="off"
            error={!isRoutingNumberValid || invalidFields.includes('routing_number')}
            helperText={!isRoutingNumberValid ? 'Routing Number is invalid' : null}
          />
          <img style={{ width: 15, height: 20 }} src="/plus_frontend/assets/txn/routing_number_symbol.gif" alt="routing number" />
        </Stack>
        <Stack flexDirection="row" alignItems="center" columnGap={2}>
          <TextField
            sx={{ flex: 1, marginLeft: 2.9 }}
            label="Bank Account #"
            size="small"
            type="password"
            value={payout.bankAccountNumber}
            onChange={(e) => setPayout({ ...payout, bankAccountNumber: e.target.value.replace(/\D/g, '') })}
            error={accountNumberErrored || invalidFields.includes('account_number')}
          />
          <img style={{ width: 15, height: 20 }} src="/plus_frontend/assets/txn/account_number_symbol.gif" alt="account number" />
        </Stack>
        <Stack flexDirection="row" alignItems="center" columnGap={2} flex={1}>
          <TextField
            sx={{ flex: 1, marginLeft: 2.9 }}
            label="Re-Type Bank Account #"
            size="small"
            type="password"
            value={payout.accountNumberConfirmation}
            onChange={(e) => setPayout({ ...payout, accountNumberConfirmation: e.target.value.replace(/\D/g, '') })}
            error={accountConfirmationError || invalidFields.includes('account_number_confirmation')}
          />
          <img style={{ width: 15, height: 20 }} src="/plus_frontend/assets/txn/account_number_symbol.gif" alt="account number" />
        </Stack>
      </Stack>
    </Stack>
  );
};

BankAccountDetails.propTypes = {
  payout: PropTypes.object.isRequired,
  setPayout: PropTypes.func.isRequired,
  invalidFields: PropTypes.array.isRequired,
};

export default BankAccountDetails;
